export const translations = {
  configuracoes: {
    pt: "Configurações",
    en: "Settings",
    de: "Einstellungen",
    es: "Configuración",
  },
  novaPlanta: {
    pt: "Nova Planta",
    en: "New Plant",
    de: "Neuer Produkttyp",
    es: "Nueva Planta",
  },
};
